<template>
  <resource-card
    :blockData="{
      resource: resource,
      excerpts: excerpts
    }"
    tabindex="0"
    blockType="note"
    @delete="userCanEdit ? $emit('removeNoteBlock', { noteId: subNote.id }) : null"
    @click=""
    color="transparent"
  >
    <template v-slot="props" name="after">
      <div :style="`position: absolute; right: 10px;`" v-if="props.hover || showPreview">
        <v-btn
          icon
          small
          @click="userCanEdit ? $emit('removeNoteBlock', { noteId: subNote.id }) : null"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-menu v-model="showPreview" :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <v-btn icon small v-on="on">
              <v-icon>more_horiz</v-icon>
            </v-btn>
          </template>
          <resource-details-card :resource="resource" showOpen></resource-details-card>
        </v-menu>
      </div>
    </template>
  </resource-card>
</template>

<script>
import ResourceCard from '@/components/Resources/ResourceCard';
import ResourceDetailsCard from '@/components/Resources/ResourceDetailsCard';

export default {
  props: ['resource', 'subNote', 'userCanEdit'],
  data() {
    return {
      showPreview: false
    };
  },
  components: { ResourceCard, ResourceDetailsCard },
  computed: {
    excerpts() {
      if (this.subNote.content.widgetData.resourceNoteIds) {
        return this.subNote.content.widgetData.resourceNoteIds.map(e =>
          this.resource ? this.resource.noteBlocks[e] : []
        );
      } else {
        return [];
      }
    }
  }
};
</script>

<style></style>
